import React from 'react';
import {connect} from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css';
import Input from "~/components/pages/MyAccount/share/Input";
import Button from '~/components/common/Button';
import * as modes from '~/modules/modal/modes';
import { makeBidDynamic } from '~/modules/bids/actions'
import { status as loadStatus } from "~/misc/loadStatus";
import {modalClose, modalChange} from '~/modules/modal/actions';
import {getBidsLoads} from '~/modules/bids/actions'
import accounting from '~/misc/accounting'
import { track } from '~/misc/metrics';
import { getLocation, getSearchId } from "~/misc/actionLocation";
class CreateBid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offer: null
    }
  }
  componentDidMount() {
    const { context: { shipmentId } , bid} = this.props
    const { price } = bid.get(shipmentId) || {price: null}
    this.setState({
      offer: price
    })
  }
  handleChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.name]: accounting.formatMoney(e.target.value.replace(/[^0-9]/g, ''))
    })
  } 
  makeBid = () => {
    const { offer } = this.state;
    const {  makeBidDynamic ,showResult, getBidsLoads, context:{ shipmentId ,brokerName, nextNode}} = this.props;
    const message = '1';
    
    makeBidDynamic({
      price: Number(offer.replace(/[^0-9]/g, '')),
      shipmentId,
      nextNode
    }).then(({ code, id})=> {
      getBidsLoads();
      switch (code) {
        case loadStatus.BID_SUCCESS: {
          track("Bid Results", {
            Result: "Success",
            loadId: shipmentId,
            searchId: getSearchId(),
            Placement: getLocation(),
            BookId: id,
          })
          return showResult({result: 'success', message: 'Brokers typically respond in 24 hours, continue searching and make more offers.', brokerName, offer})
        }
        default: {
          track("Bid Results", {
            Result: "Failed",
            loadId: shipmentId,
            searchId: getSearchId(),
            Placement: getLocation(),
            BookId: id,
          })
          return showResult({result: 'fail', message: 'An error occurred, refresh your load list to continue searching and make offers for other loads.', brokerName, offer}); 
        }
      }
    }).catch(err=> {
      return showResult({result: 'fail', message: 'An error occurred, refresh your load list to continue searching and make offers for other loads.', brokerName, offer}); 
    })
  }
  render() {
    const {error , offer} = this.state;
    const { context: { curRate } } = this.props
    if (isEmpty(this.props.context)) {
      return null;
    }
    return (
      <div className={css.popwrap}>
        <div className={css.title}>Your Offer</div>
        <div className={css.formInputs}>
          <Input
            mods={["floatLef", "strench"]}
            title={"Current Rate"}
            label={"curRate"}
            readonly={true}
            type="text"
            defaultValue={ accounting.formatMoney(curRate) }
          />
          <Input
            mods={["floatLef", "strench"]}
            title={"Your Offer"}
            label={"offer"}
            fnChange={this.handleChange}
            error={error}
            type="text"
            defaultValue={ accounting.formatMoney(offer) }
          />
        </div>
        <div className={css.btnGroup}>
          <Button  
            onClick={this.props.closePop}
            mods={['large']}>Not Now</Button>
          <Button
            mods={['large', 'action']}
            onClick={this.makeBid}
            disabled={!offer}
            className={cs({
              [css.button]: offer
            })}
          >Make an offer</Button>
        </div>
      </div>
    )
  }
}

export default connect(({bids})=>{
  const { map = new Map() } = bids;
  return {
    bid: map
  }
}, mapDispatch({
  closePop: () => modalClose(modes.CREATE_BID),
  makeBidDynamic: (props, {shipmentId, price, nextNode}) => makeBidDynamic({shipmentId, price, nextNode}),
  showResult: (props, {
    result,
    message,
    brokerName, 
    offer
  })  => modalChange(modes.CREATE_BID_RESULT, {type: 'askPop', result, message, brokerName, offer}),
  getBidsLoads: () => getBidsLoads()
}))(CreateBid);




// WEBPACK FOOTER //
// ./src/components/Popup/CreateBid/index.js